module.exports = __webpack_public_path__ + "img/goal-thirteen-br.f727a773.png";